<template>
  <div class="row mb-4 font-weight-bold"> {{ $t('demand.tabs.conditions') }}</div>
               <div class="col-12">
                  <div class="row">
                    <label class="font-weight-bold" v-if="!orderConditions?.length">
                      {{ $t("order.orderConditions.NoConditionFound") }} 
                    </label>
                    <div v-else class="col-md-4 mb-4" v-for="condition in orderConditions" :key="condition.id">
                      <q-checkbox
                        v-model="condition.checked"
                        :label="$t('order.orderConditions.list.'+condition?.condition?.resourceUid)"
                        dense
                        disable
                        class="font-size-12"
                      />
                    </div>
                  </div>
              </div>
  </template>
  
  <script lang="ts">
import { Options, Vue } from 'vue-class-component';
  
  @Options({
  props: ["orderConditions"],
})
export default class OrderSummaryConditions extends Vue {
  orderConditions?: Array<any>;

}
  </script>
  
<style scoped>
</style>